import dayjs from "dayjs";
import styles from "./styles.module.css";

export default function RegistrosRondaDiasContagem({ registros, filtro }: iProps) {
    if (registros.length === 0) {
        return <div></div>;
    }

    /**
     * Retorna um array com todas as datas entre dataInicial e dataFinal (inclusive).
     * @param dataInicial Data de início (string)
     * @param dataFinal Data de fim (string)
     * @returns Array com os dias
     */
    function listarDiasEntreDatas(dataInicial: string, dataFinal: string): any[] {
        const inicio = dayjs(dataInicial);
        const fim = dayjs(dataFinal);
        const dias: any[] = [];

        let atual = inicio;
        while (atual.isBefore(fim) || atual.isSame(fim, "day")) {
            dias.push({
                data_dia: atual.format("YYYY-MM-DD"),
                quantidade: 0,
            });
            atual = atual.add(1, "day");
        }
        return dias;
    }

    let dias: any[] = listarDiasEntreDatas(filtro.data_inicial, filtro.data_final);
    for (let reg of registros) {
        let data_dia = reg.data_dia;
        for (let idx in dias) {
            if (dias[idx].data_dia === data_dia) {
                dias[idx].quantidade += 1;
                break;
            }
        }
    }

    return (
        <div>
            <p className={styles.contagemTitulo}>Rondas por DIA</p>
            <div style={{ lineHeight: "25px", textAlign: "justify" }}>
                {dias
                    .reverse()
                    .filter((reg) => reg.quantidade > 0)
                    .map((dia, idx, arr) => {
                        // {dias.filter((reg) => reg.quantidade > 0).map((dia, idx, arr) => {
                        return (
                            <div key={idx} className={styles.qtdRegPorDia}>
                                <span>
                                    {dayjs(dia.data_dia).format("DD/MM")} {dayjs(dia.data_dia).locale("pt-BR").format("dddd").substring(0, 3)} <b>{dia.quantidade}</b>
                                </span>
                            </div>
                        );
                    })}
            </div>
            <br></br>
        </div>
    );
}
interface iProps {
    registros: any[];
    filtro: any;
}
